import { Component, OnInit } from "@angular/core";
import { ProductService } from "../../../shared/services/product.service";
import { DetalharprodutoComponent } from "../../detalharproduto/detalharproduto.component";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as unidecode from "unidecode";

@Component({
  selector: "app-search-produtos",
  templateUrl: "./search-produtos.component.html",
  styleUrls: ["./search-produtos.component.scss"],
})
export class SearchProdutosComponent implements OnInit {
  products: any[] = [];
  newItems: any[] = [];

  public searchForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private modalService: NgbModal,
    public toastrService: ToastrService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.productService.productsList$.subscribe(
      (response) => (this.products = response)
    );

    this.searchForm = this.formBuilder.group({
      termoPesquisa: [null],
    });
  }

  ngOnInit(): void {
    if (!localStorage.getItem('location')) this.router.navigateByUrl('/home/fashion');
  }

  procurarItem(): void {
    const itemProcurado = unidecode(
      this.searchForm.value.termoPesquisa.toLowerCase()
    );
    this.newItems = this.products.filter(
      (x) => unidecode(x.title.toLowerCase()).includes(itemProcurado)
    );

    if (this.newItems.length === 0) {
      this.toastrService.warning("Nenhum produto encontrado.", "Atenção");
    } else {
      this.searchForm.reset();
    }
  }

  addToCart(product: any) {
    this.productService.addToCart(product);
  }

  detalharProduto(product: any) {
    const modalRef = this.modalService.open(DetalharprodutoComponent, {
      size: "lg",
      ariaLabelledBy: "modal-basic-title",
      centered: true,
      windowClass: "Quickview",
    });

    modalRef.componentInstance.product = product;
    modalRef.componentInstance.currency = this.productService.Currency;
  }

  addToWishlist(product: any) {
    this.productService.addToWishlist(product);
  }

  addToCompare(product: any) {
    this.productService.addToCompare(product);
  }

  limpar() {
    this.searchForm.reset();
    this.newItems = [];
  }
}
